import styled from '@emotion/styled';
import { isEmpty } from 'lodash/fp';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PageLayout from '~/common/components/GlobalLayout/PageLayout/PageLayout';
import LeftDrawerWrapper from '~/common/components/Nav/LeftDrawer/components/LeftDrawerWrapper';
import SelectedLeftDrawerContent from '~/common/components/Nav/LeftDrawer/components/SelectedLeftDrawerContent';
import { useUser } from '~/common/hooks/useAuthentication';
import { getNextCategoryAlert } from '~/common/util/ruleUtils';
import ClassifyDocumentsV2 from '~/pages/ClassifyDocumentsV2/ClassifyDocumentsV2';

import CategoriesHeader from './CategoriesHeader';
import { CategoryToDisplay } from './RouterConstants';
import { CATEGORY_IDS } from './constants';
import { HomeActions } from './redux';

const StyledHomeMain = styled.main`
  @media (min-width: 1441px) {
    display: flex;
    justify-content: center;
  }
`;

const HomeContainer = () => {
  const dispatch = useDispatch();
  const {
    home,
    loanSummaryUpsertOrDelete: { loanSummaryUpsertOrDelete },
  } = useSelector((state) => state);
  const { isUnderwriter } = useUser();
  const selectedAlert = home?.selectedAlert;
  const selectedCategory = home.selectedCategory;
  const { navigationItems } = home;

  const alerts = navigationItems?.categories?.find(
    (category) => category?.navigationCategoryId === selectedCategory,
  )?.navigationGutterItems;

  useEffect(() => {
    if (
      alerts?.length > 0 &&
      selectedAlert === null &&
      !loanSummaryUpsertOrDelete
    ) {
      const nextAlert = getNextCategoryAlert(alerts);
      dispatch(HomeActions.setSelectedAlert(nextAlert));
    }
  }, [alerts, selectedAlert, loanSummaryUpsertOrDelete, dispatch]);

  const showContent = selectedAlert && !isEmpty(selectedAlert);

  return (
    <StyledHomeMain>
      <PageLayout
        leftDrawerContent={
          <LeftDrawerWrapper>
            <SelectedLeftDrawerContent selectedCategory={selectedCategory} />
          </LeftDrawerWrapper>
        }
        topNav={<CategoriesHeader />}
      >
        {selectedCategory === CATEGORY_IDS.CLASSIFY ? (
          <ClassifyDocumentsV2 />
        ) : (
          <>
            {showContent && (
              <CategoryToDisplay
                subId={selectedAlert?.ruleSubCategoryId}
                ruleId={selectedAlert?.ruleId}
                additionalReferences={selectedAlert?.additionalReferences}
                isUnderwriter={isUnderwriter}
              />
            )}
          </>
        )}
      </PageLayout>
    </StyledHomeMain>
  );
};

export default HomeContainer;
